import { useQuery } from "react-query";
import { recommendationsApi } from "@/react/api/recommendations/recommendationsApi";

export const useRecommendations = () =>
  useQuery("recommendations", recommendationsApi.getRecommendations);
